/* ================================================
   WISHLIST MANAGER — Hyper Theme
   ================================================ */
window.WL = (function() {
  var KEY = 'shopify_wishlist';
  var SHARE_PARAM = 'wl';

  /* --- Storage --- */
  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch(e) { return []; }
  }
  function save(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('wl:updated', { detail: { items: items } }));
  }

  /* --- Core Actions --- */
  function add(data) {
    var list = get();
    if (has(data.productId)) return false;
    list.push({
      id: String(data.productId),
      handle: data.productHandle,
      title: data.productTitle,
      price: data.productPrice,
      image: data.productImage,
      addedAt: new Date().toISOString()
    });
    save(list);
    return true;
  }
  function remove(pid) {
    var list = get().filter(function(i) { return i.id !== String(pid); });
    save(list);
  }
  function has(pid) {
    return get().some(function(i) { return i.id === String(pid); });
  }
  function count() { return get().length; }
  function clear() { save([]); }

  /* --- Share --- */
  function shareLink() {
    var list = get();
    if (!list.length) return '';
    var compact = list.map(function(i) { return [i.id, i.handle]; });
    return window.location.origin + '/pages/wishlist?' + SHARE_PARAM + '=' + btoa(JSON.stringify(compact));
  }
  function parseShare() {
    var p = new URLSearchParams(window.location.search).get(SHARE_PARAM);
    if (!p) return null;
    try {
      return JSON.parse(atob(p)).map(function(i) { return { id: i[0], handle: i[1] }; });
    } catch(e) { return null; }
  }
  function fetchShared(items) {
    var promises = items.map(function(item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(p) {
          if (!p) return null;
          var img = p.images && p.images[0] ? p.images[0] : '';
          var price = '$' + (p.price / 100).toFixed(2);
          if (window.Shopify && Shopify.currency && Shopify.currency.active && Shopify.currency.active !== 'USD') {
            price = p.price; // fallback
          }
          return {
            id: String(p.id),
            handle: p.handle,
            title: p.title,
            price: price,
            image: img,
            url: '/products/' + p.handle,
            available: p.available
          };
        })
        .catch(function() { return null; });
    });
    return Promise.all(promises).then(function(results) {
      return results.filter(Boolean);
    });
  }

  /* --- Toast --- */
  function toast(msg) {
    var el = document.getElementById('wl-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'wl-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(el._t);
    el._t = setTimeout(function() { el.classList.remove('show'); }, 2200);
  }

  /* --- Init Heart Buttons --- */
  function initHearts() {
    document.querySelectorAll('.wishlist-toggle:not(.wl-initialized)').forEach(function(btn) {
      btn.classList.add('wl-initialized');
      var pid = btn.dataset.productId;

      // Set initial state
      if (has(pid)) {
        btn.classList.add('is-active');
      }

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var data = {
          productId: btn.dataset.productId,
          productHandle: btn.dataset.productHandle,
          productTitle: btn.dataset.productTitle,
          productPrice: btn.dataset.productPrice,
          productImage: btn.dataset.productImage
        };

        if (has(pid)) {
          remove(pid);
          btn.classList.remove('is-active');
          toast('Removed from wishlist');
        } else {
          add(data);
          btn.classList.add('is-active', 'just-added');
          setTimeout(function() { btn.classList.remove('just-added'); }, 400);
          toast('Added to wishlist');
        }
        updateBadges();
      });
    });
  }

  /* --- Count Badges --- */
  function updateBadges() {
    document.querySelectorAll('.wl-count').forEach(function(el) {
      var c = count();
      el.textContent = c;
      el.style.display = c > 0 ? 'flex' : 'none';
    });
  }

  /* --- Observe DOM changes for AJAX-loaded products --- */
  function observe() {
    if (window.MutationObserver) {
      new MutationObserver(function() {
        initHearts();
        updateBadges();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* --- Auto-init --- */
  function init() {
    initHearts();
    updateBadges();
    observe();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* --- Public API --- */
  return {
    get: get, add: add, remove: remove, has: has,
    count: count, clear: clear,
    shareLink: shareLink, parseShare: parseShare, fetchShared: fetchShared,
    initHearts: initHearts, updateBadges: updateBadges, toast: toast
  };
})();